
import React from "react";
import { Sidebar } from "./Sidebar";
import IntercomChat from "../IntercomChat";
import { useIsMobile } from "@/hooks/use-mobile";
import { HossHeader } from "./HossHeader";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex h-screen w-full bg-white text-hossTeal">
      <Sidebar />
      <div className="flex-1 overflow-auto flex flex-col grid-background">
        <HossHeader />
        <div className="min-h-full w-full animate-fade-in flex-1">
          {children}
        </div>
      </div>
      {!isMobile && <IntercomChat />}
    </div>
  );
};
